<template>
  <div class="row">
    <div class="col-12 m-t-b-sm">
      <small>{{$t('management.customOs.unmountIsoInfo')}}</small>
    </div>
    <div class="col-md-12 col-sm-12 row-action">
      <form @submit.prevent="submitFile" ref="formUpload">
        <div class="form-group-w-btn">
          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required/>
          <button type="submit" class="btn btn-micro btn-primary">
            {{$t('management.customOs.uploadIsoPlaceholder')}}
          </button>
        </div>
      </form>
    </div>
    <div class="col-12" v-show="showLoadBar">
      <vuestic-progress-bar size="thick" ref="hThick">
      </vuestic-progress-bar>
    </div>
  </div>
</template>

<script>
  import {getAxios} from 'services/ajaxFile'

  export default {
    name: "CustomIsoUploadIso",
    data() {
      return {
        valueVersion: null,
        valueAnimationInterval: 3000,
        showLoadBar: false
      }
    },
    methods: {
      handleFileUpload() {
        const self = this;

        const fileInput = this.$refs.file;

        if (fileInput.files.length > 0) {
          this.file = fileInput.files[0];

          const fileName = this.file.name;

          if (!fileName.toLowerCase().endsWith('.iso')) {
            self.$emit('show','selectTrueIso')

            this.file = null;
            fileInput.value = '';
          }
        }
      },
      loadProgress(progress) {
        let delay = 0;

        this.$refs['hThick'].$data.valueAnimationInterval = this.valueAnimationInterval
        this.$refs['hThick'].$data.value = progress

        delay += this.valueAnimationInterval
      },
      submitFile() {
        this.showLoadBar = true
        const self = this;

        let formData = new FormData();

        formData.append('file', this.file);

        getAxios().post('/custom_iso/upload', formData,
          {
            onUploadProgress: function (progressEvent) {
              this.loadProgress(parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
            }.bind(this)
          }
        )
          .then(response => {
            this.file = null

            self.$emit('show', response.data.message)

            this.$refs.formUpload.reset();
          })
          .catch(err => {
            self.$emit('show', err.response.data.message)
          })
          .finally(() => {
            this.showLoadBar = false
          });
      },
    }
  }
</script>

<style scoped>
  small {
    font-size: 1rem;
  }
  .row-action {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .m-t-b-sm {
    margin-bottom: 15px;
    margin-top: 15px;
  }

  .form-group input {
    height: 55px !important;
  }

  .form-group-w-btn {
    display: flex;
    justify-content: space-between;
  }

  input[type=file]::file-selector-button {
    background-color: #b64afd;
    color: #fff;
    padding: 0.625rem 1.8rem;
    font-size: 85%;
    line-height: 1.25;
    border-radius: 1.875rem;
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomIso/CustomIsoUploadIso.vue